import { LeadProduct } from "@/components/molecules/parts/LeadProduct";
import Image from "next/image";
import coverProduct from "/public/cover-product.webp";

export const ProductCover = (props) => {
  return (
    <>
      <div className="box-border    w-full bg-bgc-darker">
        <div className="mx-auto flex aspect-1.91/1 max-h-[800px] max-w-7xl flex-col items-center justify-end gap-6  py-10 px-6 md:flex-row md:gap-10 md:px-10 md:py-5 lg:gap-16 lg:px-20">
          <div className="relative z-10 mx-auto flex w-full flex-col items-start justify-start gap-4 md:max-w-[188px] md:gap-6 lg:max-w-unit-1">
            <h3 className="font-bold text-nvy fluid-text-[14px,22px]">
              Product
            </h3>
            <h2 className="relative z-10">
              <LeadProduct className="h-auto w-full fill-nvy 2xs:max-w-[220px] xs:max-w-[264px] md:max-w-[188px] lg:max-w-unit-1" />
            </h2>
            <h5 className="w-full text-justify font-bold leading-comfort text-nvy fluid-text-[12px,16px] ">
              お客様の抱える様々なご要望や課題を、より良いカタチにするために、
              <br className="br_sm" />
              柔軟な拡張性を重視し、コア機能を充実させた、
              <br className="br_sm" />
              成長運用を実現するためのシステムをご提供しています。
            </h5>
          </div>
          <div className="relative z-0 mx-auto flex aspect-1.45/1 w-full items-center justify-center sm:max-w-[400px] md:max-w-none">
            <Image
              src={coverProduct}
              alt="ToccaSystems's Product"
              quality={50}
              layout="fill"
              objectFit="cover"
            />
          </div>
        </div>
      </div>
    </>
  );
};
